export default __webpack_public_path__ + "static/media/fontname.0244264f.svg";